/**
 * This file contains all of the quiz questions, responces and scoring values.
 * To change the text see functions.php and Polylang.
 */
export default [
  {
    id: 1,
    question: lang.QUIZ_Q1,
    responces: [
      {
        text: lang.QUIZ_A1_1,
        value: 'community-outreach',
      },
      {
        text: lang.QUIZ_A1_2,
        value: 'semi-intensive',
      },
      {
        text: lang.QUIZ_A1_3,
        value: 'intensive',
      },
    ],
  },
  {
    id: 2,
    question: lang.QUIZ_Q2,
    responces: [
      {
        text: lang.QUIZ_A2_1,
        value: 'community-outreach',
      },
      {
        text: lang.QUIZ_A2_2,
        value: 'semi-intensive',
      },
      {
        text: lang.QUIZ_A2_3,
        value: 'intensive',
      },
    ],
  },
  {
    id: 3,
    question: lang.QUIZ_Q3,
    responces: [
      {
        text: lang.QUIZ_A3_1,
        value: 'community-outreach',
      },
      {
        text: lang.QUIZ_A3_2,
        value: 'semi-intensive',
      },
      {
        text: lang.QUIZ_A3_3,
        value: 'intensive',
      },
    ],
  },
  {
    id: 4,
    question: lang.QUIZ_Q4,
    responces: [
      {
        text: lang.QUIZ_A4_1,
        value: 'community-outreach',
      },
      {
        text: lang.QUIZ_A4_2,
        value: 'semi-intensive',
      },
      {
        text: lang.QUIZ_A4_3,
        value: 'intensive',
      },
    ],
  },
  {
    id: 5,
    question: lang.QUIZ_Q5,
    responces: [
      {
        text: lang.QUIZ_A5_1,
        value: 'community-outreach',
      },
      {
        text: lang.QUIZ_A5_2,
        value: 'semi-intensive',
      },
      {
        text: lang.QUIZ_A5_3,
        value: 'intensive',
      },
    ],
  },
];